<template>
  <div
    v-click-outside="$_popupClose"
    class="help-tool"
  >
    <i
      class="icon-help-outline"
      @click="$_popupToggle()"
    />
    <div>
      <div>
        <transition mode="out-in">
          <div
            v-if="active.popupShow"
            class="help-tool__popup"
          >
            <div
              v-for="(item,item_k) in popupList"
              :key="item_k"
              class="help-tool__popup__item"
              @click="$_selectItem(item)"
            >
              {{ item.textLabel }}
            </div>
          </div>
        </transition>
      </div>
    </div>
    <PopUp
      v-if="active.feedback"
      :clickOutsideClose="false"
      :pop-up-active="active.feedback"
      :title="$t('意見回饋')"
      @click="$_feedbackPopupClose()"
    >
      <LlCancelPopupContent v-if="!active.giveUpFeedback && !active.send">
        <ValidationObserver ref="formObserver">
          <InputListCard>
            <div class="input-item">
              <LlState
                v-model="feedbackData.name"
                :title="fields.name.label"
                :type="fields.name.type"
                :placeholder="fields.name.placeholder"
                :rules="fields.name.rules"
                :is-required="fields.name.isRequired"
              />
            </div>
            <div class="multiple-input-item">
              <div
                class="input-item"
                style="min-width: 200px;"
              >
                <LlState
                  v-model="feedbackData.contact_way"
                  :title="fields.contact_way.label"
                  :type="fields.contact_way.type"
                  :dropdown-menu-items="fields.contact_way.menuItems"
                  :rules="fields.contact_way.rules"
                  :is-required="fields.contact_way.isRequired"
                  :default-value="fields.contact_way.defaultValue"
                />
              </div>
              <div
                class="input-item"
                style="width: 100%;"
              >
                <LlState
                  v-show="feedbackData.contact_way==='tel'"
                  v-model="feedbackData.tel"
                  :title="fields.tel.label"
                  :type="fields.tel.type"
                  :placeholder="fields.tel.placeholder"
                  :rules="fields.tel.rules"
                  :is-required="fields.tel.isRequired"
                />
                <LlState
                  v-show="feedbackData.contact_way==='email'"
                  v-model="feedbackData.email"
                  :title="fields.email.label"
                  :type="fields.email.type"
                  :placeholder="fields.email.placeholder"
                  :rules="fields.email.rules"
                  :is-required="fields.email.isRequired"
                />
              </div>
            </div>
            <div class="multiple-input-item">
              <div
                class="input-item"
                style="min-width: 200px;"
              >
                <LlState
                  v-model="feedbackData.category"
                  :title="fields.category.label"
                  :type="fields.category.type"
                  :dropdown-menu-items="fields.category.menuItems"
                  :rules="fields.category.rules"
                  :is-required="fields.category.isRequired"
                  :default-value="fields.category.defaultvalue"
                />
              </div>
              <div
                class="input-item"
                style="width: 100%;"
              >
                <LlState
                  v-model="feedbackData.subject"
                  :title="fields.subject.label"
                  :type="fields.subject.type"
                  :placeholder="fields.subject.placeholder"
                  :rules="fields.subject.rules"
                  :is-required="fields.subject.isRequired"
                  :default-value="fields.subject.defaultvalue"
                />
              </div>
            </div>
            <div class="input-item">
              <div class="input">
                <LlState
                  v-model="feedbackData.remark"
                  :title="fields.remark.label"
                  :type="fields.remark.type"
                  :rules="fields.remark.rules"
                  :is-required="fields.remark.isRequired"
                  :placeholder="fields.remark.placeholder"
                  :min-height="134"
                >
                  <template v-slot:button>
                    <UploadFileButton
                      v-model="feedbackData.attaches"
                      text
                      :factory="_currentFactoryId"
                      :text-label="$t('附件')"
                      upload-url="/feedback/attach/"
                      multiple
                    />
                  </template>
                  <template
                    v-if="feedbackData.attaches.length > 0"
                    v-slot:attaches
                  >
                    <div>
                      <LlFileList
                        :attaches="feedbackData.attaches"
                        outline
                        upload
                        two-item
                        narrow
                        :margin-top="20"
                        @delete-file="$_deleteAttach($event)"
                      />
                    </div>
                  </template>
                </LlState>
              </div>
            </div>
          </InputListCard>
        </ValidationObserver>
        <template v-slot:buttons>
          <WsButton001
            width200
            out-line
            @click="$_feedbackGiveUp()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001 @click="$_feedbackSubmit()">
            {{ $t('送出') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
      <LlCancelPopupContent
        v-if="active.giveUpFeedback && !active.send"
        :cancel-text="$t('確定捨棄嗎？')"
      >
        <template v-slot:buttons>
          <WsButton001
            outLine
            @click="$_feedbackContinue()"
          >
            {{ $t('取消') }}
          </WsButton001>
          <WsButton001
            @click="$_feedbackPopupClose()"
          >
            {{ $t('確定') }}
          </WsButton001>
        </template>
      </LlCancelPopupContent>
      <LlCancelPopupContent v-if="active.send">
        <LlSos v-if="active.send" />
      </LlCancelPopupContent>
    </Popup>
    <PopUp
      v-else
      :pop-up-active="active.feedback"
      @click="$_feedbackPopupClose()"
    />
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
export default {
  name: "HelpTool",
  directives: {
    ClickOutside,
  },
  data() {
    return {
      active: {
        feedback: false,
        giveUpFeedback: false,
        send: false,
        popupShow: false,
      },
      popupList: [
        {
          textLabel: this.$t("關於我們"),
          type: "new_page",
          url: "https://www.esgoal.com.tw/about",
        },
        // {
        //   textLabel: this.$t("意見回饋"),
        // },
        {
          textLabel: this.$t("條款政策"),
          type: "new_page",
          url: "https://www.esgoal.com.tw/privacy",
        },
      ],
      feedbackData: {
        name: "",
        contact_way: null,
        tel: "",
        email: "",
        category: null,
        subject: this.$t("選項一內容"),
        attaches: [],
        remark: "",
      },
      fields: {
        name: {
          label: this.$t("聯絡人姓名"),
          type: "text",
          isRequired: true,
          placeholder: this.$t("輸入"),
          rules: "required",
        },
        contact_way: {
          label: this.$t("聯絡方式"),
          type: "dropdown",
          isRequired: true,
          defaultValue: "email",
          menuItems: [
            {
              id: "tel",
              textLabel: this.$t("手機"),
            },
            {
              id: "email",
              textLabel: this.$t("信箱"),
            },
          ],
        },
        tel: {
          label: this.$t("手機號碼"),
          type: "text",
          isRequired: true,
          rules: "required|number",
          placeholder: "0900-000-000",
        },
        email: {
          label: this.$t("信箱"),
          type: "text",
          isRequired: true,
          rules: "required|email",
          placeholder: "aa@xxxxxx.com",
        },
        category: {
          label: this.$t("類別"),
          type: "dropdown",
          isRequired: true,
          rules: "required",
          placeholder: this.$t("選擇"),
          defaultValue: "0",
          menuItems: [
            {
              id: "0",
              textLabel: this.$t("選項一"),
            },
            {
              id: "1",
              textLabel: this.$t("選項二"),
            },
            {
              id: "2",
              textLabel: this.$t("其他"),
            },
          ],
        },
        subject: {
          label: this.$t("主旨"),
          type: "text",
          isRequired: true,
          rules: "required",
          placeholder: this.$t("輸入"),
          defaultValue: "選項一內容",
        },
        remark: {
          label: this.$t("簡述"),
          type: "textarea",
          isRequired: true,
          rules: "required",
          placeholder: this.$t("輸入"),
        },
      },
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
  },
  watch: {
    "feedbackData.category": {
      handler() {
        if (this.feedbackData.category === "0") {
          this.feedbackData.subject = "選項一內容";
        } else if (this.feedbackData.category === "1") {
          this.feedbackData.subject = "選項二內容";
        } else {
          this.feedbackData.subject = "其他內容";
        }
      },
      deep: true,
    },
  },
  methods: {
    $_selectItem(item) {
      this.active.popupShow = !this.active.popupShow;
      if (item.type === "new_page" || !item.type) {
        if (item.url) {
          window.open(item.url, "_blank");
        }
      } else if (item.type === "popup") {
        if (item.value === "0") {
          this.$_feedbackPopupOpen();
        }
      }
    },
    $_popupToggle() {
      this.active.popupShow = !this.active.popupShow;
    },
    $_popupClose() {
      this.active.popupShow = false;
    },
    $_feedbackPopupClose() {
      this.active.feedback = false;
    },
    $_feedbackPopupOpen() {
      this.$_clearfeedbackData();
      this.feedbackData.subject = this.$t("選項一內容");
      this.active.feedback = true;
      this.active.giveUpFeedback = false;
      this.active.send = false;
    },
    async $_feedbackSubmit() {
      const isValidate = await this.$refs.formObserver.validate();
      if (!isValidate) {
        return;
      }
      this.active.send = true;
      let attaches = this.feedbackData.attaches.map((img) => img.url);
      let feedbackData = {
        contact_person: this.feedbackData.name,
        contact_way: this.feedbackData.contact_way,
        tel: this.feedbackData.tel,
        email: this.feedbackData.email,
        remark: this.feedbackData.remark,
        attaches: attaches,
        user: this._currentUser.id,
        factory: this._currentFactory.id,
        user_payload: {
          id: this._currentUser.id,
          name: this._currentUser.name,
        },
      };
      try {
        await this.$axios.post(
          `/factory/${this._currentFactoryId}/feedback`,
          feedbackData
        );
      } catch (err) {
        alert(this.$t("意見回饋送出失敗"));
      }
    },
    $_feedbackGiveUp() {
      let feedbackContent = false;
      for (let dataKey in this.feedbackData) {
        if (this.feedbackData[dataKey]) {
          feedbackContent = true;
        }
      }
      if (feedbackContent) {
        this.active.giveUpFeedback = true;
        return;
      }
      this.$_feedbackPopupClose();
    },
    $_feedbackContinue() {
      this.active.giveUpFeedback = false;
    },
    $_clearfeedbackData() {
      this.feedbackData = {
        name: "",
        email: "",
        tel: "",
        remark: "",
        attaches: [],
        category: "0",
        contact_way: "tel",
      };
    },
    $_deleteAttach($event) {
      this.feedbackData.attaches.splice($event, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/help-tool";
</style>
